import {
    createContext,
    useContext,
    type FC
} from "react";
import {
    View
} from "react-native";
import type {
    DataTableExpandTriggerProps
} from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    NCoreUIKitIcon
} from "../../../../types";
import {
    useDataTableContext
} from "../../context";
import {
    ChevronDown as ChevronDownIcon,
    ChevronUp as ChevronUpIcon
} from "lucide-react-native";
import AnimatedIcon from "../../../animatedIcon";
import Button from "../../../button";

const DataTableExpandTriggerContext = createContext<boolean>(false);

const DataTableExpandIcon: NCoreUIKitIcon = ({
    customColor,
    color,
    size
}) => {
    const isExpanded = useContext(DataTableExpandTriggerContext);

    return <AnimatedIcon
        isTransitioned={isExpanded}
        fromIcon={ChevronDownIcon}
        customColor={customColor}
        toIcon={ChevronUpIcon}
        iconTransition="morph"
        color={color}
        size={size}
    />;
};

const DataTableExpandTrigger: FC<DataTableExpandTriggerProps> = ({
    customTheme: customThemeProp,
    isExpandable,
    controlsId,
    isExpanded,
    label,
    rowId
}) => {
    const context = useDataTableContext({
        part: "Content"
    });

    const {
        controlHeights
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context?.customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(context?.customLocalize);

    const {
        slot: slotDynamicStyle
    } = useStyles({
        slotWidth: controlHeights.small
    });

    if(!context) {
        return null;
    }

    return <View
        style={[
            stylesheet.slot,
            slotDynamicStyle
        ]}
    >
        {
            isExpandable ?
                <DataTableExpandTriggerContext.Provider
                    value={isExpanded}
                >
                    <Button
                        customTheme={customThemeProp ?? context.customTheme}
                        onPress={() => context.handleToggleExpanded(rowId)}
                        aria-controls={isExpanded ? controlsId : undefined}
                        aria-label={localize("data-table-row-details", [
                            label
                        ])}
                        icon={DataTableExpandIcon}
                        aria-expanded={isExpanded}
                        variant="ghost"
                        type="neutral"
                        size="small"
                    />
                </DataTableExpandTriggerContext.Provider>
            :
                null
        }
    </View>;
};
export default DataTableExpandTrigger;
